import ComponentLayout from "../../../../src/layouts/component-layout";
import doLink from "../../../../content/components/River/images/do-link.png";
import dontLink from "../../../../content/components/River/images/dont-link.png";
import doVisuals from "../../../../content/components/River/images/do-visuals-size.png";
import dontVisuals from "../../../../content/components/River/images/dont-visuals-size.png";
import * as React from 'react';
export default {
  ComponentLayout,
  doLink,
  dontLink,
  doVisuals,
  dontVisuals,
  React
};